export const ASSET_ALERTS_TOPBAR_BOTTOM_VALUES = [
  'last_seen_at',
  'criticality',
  'asset_type',
  'asset_subtype',
  'operating_system',
  'ip_address',
  'domain'
];

export default ASSET_ALERTS_TOPBAR_BOTTOM_VALUES;
